import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import * as detailsSelectors from '~/CreateFabricInvitation/reducers/details/selectors';
import {selectRsvpOff} from '~/CreateFabricInvitation/reducers/details/selectors';
import {getEventHostId, getEventId} from '~/common/fabric/reducers/eviteEvent/selectors';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';
import {ResponsivePanel} from '~library/organisms/ResponsivePanel';
import './NotifyGuestsOverlay.sass';
import {HIDE_NOTIFY_GUESTS_OVERLAY} from '~/CreateFabricInvitation/reducers/modals/constants';
import {UPDATE_EVENT_DETAILS} from '~/CreateFabricInvitation/reducers/details/constants';
import {notifyGuestsOverlayShowing} from '~/CreateFabricInvitation/reducers/modals/selectors';
import {getLoggedUserId} from '~/common/fabric/User/reducers/user';

const MESSAGE = 'I’ve made an update. Check it out to see what’s new.';
const [ALL, ...GROUPS] = ['all', 'yes', 'no', 'undecided'];
const TO = [ALL];

export const NotifyGuestsOverlay = (props) => {
  const eventId = useSelector(getEventId);
  const hostId = useSelector(getEventHostId);
  const loggedUserId = useSelector(getLoggedUserId);
  const host = useSelector(detailsSelectors.selectHost);
  const coHost = useSelector(detailsSelectors.selectCohostName);
  const dispatch = useDispatch();
  const showModal = useSelector(notifyGuestsOverlayShowing);
  const rsvpOff = useSelector(selectRsvpOff);

  const [message, setMessage] = useState(MESSAGE);
  let [to, setTo] = useState(TO);

  if (!showModal) return null;

  const from = hostId === loggedUserId ? host : coHost;

  const closeOverlay = (confirmationType) => {
    dispatch({
      type: UPDATE_EVENT_DETAILS,
      payload: {confirmationType},
    });
    dispatch({type: HIDE_NOTIFY_GUESTS_OVERLAY});
  };

  const handleSend = async (e) => {
    const url = `/tsunami/v1/services/event/${eventId}/broadcast`;
    try {
      await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
          q_message_type: 'guest_update_event',
          virtual_groups: [...to].join('|'),
          message,
        }),
      });
    } catch (error) {
      console.error(error);
    }
    closeOverlay('sent');
  };

  // TODO: this function was updated in the copy of this component
  // for OneStep. This logic is confusing and uses useState's wrong.
  // If you are ever touching this, feel free to copy the updated version in.
  const handleClick = (group) => {
    if (group === ALL) return setTo([ALL]);
    to = to.filter((t) => t !== ALL);

    if (to.includes(group)) to = to.filter((t) => t !== group);
    else to = [...to, group];

    if (to.length) setTo(to);
    else setTo([ALL]);
  };

  return (
    <ResponsivePanel
      isOpen
      onClose={() => closeOverlay('updated')}
      title="Send an update to your guests"
      secondaryText="Skip"
      primaryText="Send"
      showCover
    >
      <div className="notify-guests-overlay">
        <Typography variant="label2" className="notify-guests-overlay__from-lbl">
          From:
        </Typography>
        <Typography variant="paragraph2" className="notify-guests-overlay__from">
          {from}
        </Typography>
        {!rsvpOff && (
          <>
            <Typography variant="label2" className="notify-guests-overlay__send-to-lbl">
              To:
            </Typography>
            <div className="notify-guests-overlay__send-to">
              {[ALL, ...GROUPS].map((group) => {
                const modifier = to.includes(group) ? '--active' : '';
                const className = `notify-guests-overlay__send-to-group${modifier}`;

                return (
                  <Typography
                    key={group}
                    variant="label2"
                    color="pebble"
                    className={className}
                    onClick={(e) => handleClick(group)}
                  >
                    {group}
                  </Typography>
                );
              })}
            </div>
          </>
        )}
        <hr style={{margin: '1.5rem 0'}} />
        <div className="notify-guests-overlay__message-lbl">
          <Typography variant="label2">Message</Typography>
          <Input
            data-qa-id="event-update-message-body"
            type="textarea"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            className="notify-guests-overlay__message-field"
          />
        </div>
        <div className="notify-guests-overlay__actions">
          <Button
            variant="secondary"
            size="large"
            className="notify-guests-overlay__actions-btn"
            onClick={() => closeOverlay('updated')}
            data-qa-id="notify-guests__skip"
          >
            Skip
          </Button>
          <Button
            variant="primary"
            size="large"
            className="notify-guests-overlay__actions-btn"
            onClick={handleSend}
            data-qa-id="notify-guests__send"
          >
            Send
          </Button>
        </div>
      </div>
    </ResponsivePanel>
  );
};
